const state = {
    showUserId: "",
    inputGoodsType: "",
}

const mutations = {
    editShowUserId(state, id) {
        state.showUserId = id
    },
    editInputGoodsType(state, id) {
        state.inputGoodsType = id
    },
}

const actions = {

}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}
